import { useState } from "react";
import { supabase } from "../supabase";

/**
 * Profile: the name Broadside greets you by. Stored on the Supabase auth user's
 * metadata (`user_metadata.name`), so saving fires a USER_UPDATED event that
 * refreshes the session App holds — the dashboard greeting updates on its own,
 * no page reload. Falls back to the email-derived name when left blank.
 */
export function Profile({ initialName }: { initialName: string }) {
  const [name, setName] = useState(initialName);
  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function save(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setNotice(null);
    try {
      const { error } = await supabase.auth.updateUser({ data: { name: name.trim() } });
      if (error) throw error;
      setNotice("Saved.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Couldn't save your name.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="card">
      <h2>Profile</h2>
      <p className="muted small">The name Broadside greets you by.</p>
      <form onSubmit={save} className="profile-form">
        <input
          type="text"
          placeholder="Your name"
          value={name}
          maxLength={60}
          autoComplete="name"
          onChange={(e) => setName(e.target.value)}
        />
        <button type="submit" className="btn small" disabled={busy}>
          {busy ? "…" : "Save"}
        </button>
      </form>
      {error && <p className="error small">{error}</p>}
      {notice && <p className="notice small">{notice}</p>}
    </div>
  );
}
